document.addEventListener("DOMContentLoaded", function () {
  // Function to remove logo elements
  function removeLogos() {
    document
      .querySelectorAll(".sk-logo-image, .sk-logo-wrapper")
      .forEach((el) => el.remove());
  }

  // Remove logos immediately after DOM is loaded
  removeLogos();

  // Create a MutationObserver to watch for added nodes
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Ensure it's an element node
          if (node.matches(".sk-logo-image, .sk-logo-wrapper")) {
            node.remove();
          } else if (node.querySelectorAll) {
            // Also check if any child elements match the selectors
            node
              .querySelectorAll(".sk-logo-image, .sk-logo-wrapper")
              .forEach((el) => el.remove());
          }
        }
      });
    });
  });

  // Start observing the body for added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  // Optional: Disconnect observer after 10 seconds to improve performance
  setTimeout(() => {
    observer.disconnect();
  }, 10000);
});
